function Resume() {
  return (
    <>
      <div class="resume">
        <header class="resume-header">
          <h1 class="resume-h1">Avinash V</h1>
          <div class="resume-contact-info">
            <p>Email: avinash.v1311@gmail.com</p>
            <p>Phone: (+91)9629163984</p>
            <p>
              LinkedIn:
              <a
                href="http://www.linkedin.com/in/avinash-vinayagamoorthy"
                target="_blank"
              >
                linkedin.com/in/avinash_v
              </a>
            </p>
          </div>
        </header>

        <div class="resume-section"> 
          <h2>Carrer Objective</h2>
          <p>
            Seeking challenging opportunitieswhere I can fully utilize my
            analytical and technical skills for the success of my organization.
          </p>
        </div>

        <div class="resume-section">
          <h2>Work Experience</h2>
          <ul class="resume-ul">
            <li>
          <span>&#8226;</span> Joined Tata Consultancy Services(TCS) as <strong>Systems Engineer in July 2021.</strong><br />
          <span>&#8226;</span> Having 3+ years of experience in Automation UI/API testing of Web Based Applications.<br />
          <span>&#8226;</span> Having Good experience in the Object Oriented Programming (OOPS) concepts<br />
          <span>&#8226;</span> Having Good experience on Agile Methodology and JIRA<br />
          <br />
          <span>&#8226;</span><strong> SMB QA Team Automation Tester (April 2024 – Present)</strong><br />
          <span>&emsp;&#8226;</span> Implementing UI automation for Web Based application (NEED TO CHECK) using
Python and Selenium with the PageObjectModel framework.<br />
          <span>&emsp;&#8226;</span> Designing, developing, and maintaining automated test scripts to ensure high-quality software.<br />
          <span>&emsp;&#8226;</span> Explored Cypress and BrowserStack as part of proof of concept (POC) initiatives. (NEED TO CHECK)<br />
          <br />
          <span>&#8226;</span><strong> Digico QA Team Component Tester (April 2022 – March 2024)</strong><br />
          <span>&emsp;&#8226;</span> Fully responsible for manual and automation testing of the CienaBP application.<br />
          <span>&emsp;&#8226;</span> Developed a deep understanding of application design to create comprehensive
test cases.<br />
          <span>&emsp;&#8226;</span> Collaborated with cross-functional teams to identify and resolve defects and
improve testing processes.<br />
          <span>&emsp;&#8226;</span> Executed and automated test cases for both API and UI testing.<br />
          <span>&emsp;&#8226;</span> Initially focused on UI automation using Selenium and Java with the Cucumber
framework.<br />
          <span>&emsp;&#8226;</span> Implemented API automation using Java with the Rest-Assured library and
Postman collections.<br />
          <span>&emsp;&#8226;</span> Improved overall testing efficiency and accuracy through automated regression
and sanity scenarios.<br />
          <span>&emsp;&#8226;</span> Successfully reduced regression and sanity test timelines through API automation<br />
          <br />
          <span>&#8226;</span><strong>Global QA Team Automation Tester (September 2021 – March 2022)</strong><br />
          <span>&emsp;&#8226;</span> Done UI automation for the Web based application (NEED TO CHECK) using Python
and Selenium with the PageObjectModel framework.<br />
          <span>&emsp;&#8226;</span> Developed and maintained automated test scripts to ensure seamless user
experiences.<br />
          <span>&emsp;&#8226;</span> Contributed to improving test coverage and reducing manual testing efforts.<br />
          </li></ul>
        </div>

        <div class="resume-section">
          <h2>Technical Skills</h2>
          <ul class="resume-ul">
          <li>
              <span>&#8226;</span> Amazon Web Services
            </li>
            <li>
              <span>&#8226;</span> Java
            </li>
            <li>
              <span>&#8226;</span> HTML, CSS and JavaScript
            </li>
            <li>
              <span>&#8226;</span> Selenium and Cucumber BDD
            </li>
            <li>
              <span>&#8226;</span> API automation
            </li>
            <li>
              <span>&#8226;</span> Version Control (Git)
            </li>
          </ul>
        </div>

        <div class="resume-section">
          <h2>Certifications</h2>
          <ul class="resume-ul">
          <li>
              <span>&#8226;</span> AWS Certified Developer - Associate
            </li>
          <li>
              <span>&#8226;</span> AWS Certified Solution Architect - Associate
            </li>
            <li>
              <span>&#8226;</span> AWS Certified AI Practitioner
            </li>
            <li>
              <span>&#8226;</span> AWS Certified Cloud Practitioner
            </li>
          </ul>
          <br/>
          <br/>
          <h2>Online Certificate courses</h2>
          <ul class="resume-ul">
            <li>
              <span>&#8226;</span> Microsoft Azure Fundamentals : AZ-900
              (Microsoft)
            </li>
            <li>
              <span>&#8226;</span> Selenium WebDriver with Java -Basicsto
              Advanced+Frameworks (Udemy)
            </li>
            <li>
              <span>&#8226;</span> Selenium Webdriver with PYTHON from Scratch +
              Frameworks (Udemy)
            </li>
            <li>
              <span>&#8226;</span> SQL for Beginners: Learn SQL using MySQL and
              Database Design (Udemy)
            </li>
            <li>
              <span>&#8226;</span> Linux Mastery (Udemy)
            </li>
            <li>
              <span>&#8226;</span> Introduction to HTML (Coursera)
            </li>
            <li>
              <span>&#8226;</span> Introduction to CSS (Coursera)
            </li>
            <li>
              <span>&#8226;</span> Interactivity with JavaScript (Coursera)
            </li>
            <li>
              <span>&#8226;</span> Advanced Styling with Responsive Design
              (Coursera)
            </li>
          </ul>
        </div>

        <div class="resume-section">
          <h2>Personal Skills</h2>
          <ul class="resume-ul">
            <li>
              <span>&#8226;</span> Self motivated.
            </li>
            <li>
              <span>&#8226;</span> Resilient and Problem Solver.
            </li>
            <li>
              <span>&#8226;</span> Adaptable and Flexible to work Independently
              and as a Team.
            </li>
            <li>
              <span>&#8226;</span> Eagerness to learn new things.
            </li>
          </ul>
        </div>

        <div class="resume-section">
          <h2>Education</h2>
          <ul class="resume-ul">
            <li>
              <strong>B.E. Electronics and Communication Engineering</strong> -
              College of Engineering Guindy, Anna University
              <p>Graduated in 2021 with a CGPA of 8.47</p>
            </li>
            <li>
              <strong>Class XII (HSC)</strong> - CEOA matriculation higher
              secondary school
              <p>Completed in 2017 with 98.9%</p>
            </li>
            <li>
              <strong>Class X (Matric)</strong> - MTPKN matric. higher secondary
              school
              <p>Completed in 2021 with 94.8%</p>
            </li>
          </ul>
        </div>

        <div class="resume-section">
          <h2>Other Details</h2>
          <ul class="resume-ul">
            <li>
              <span>&#8226;</span> Date of Birth : 13 Nov 1999
            </li>
            <li>
              <span>&#8226;</span> Languages Known : English, Tamil
            </li>
            <li>
              <span>&#8226;</span> Hobbies : Puzzles, Rubik’s cube
            </li>
          </ul>
        </div>

        <div class="resume-section">
          <h2>Projects</h2>
          <ul class="resume-ul">
            <li>
              <strong> TollGate And Vehicle Entry</strong>
              <span> - </span>
              <a href="http://aviiiiii.online/tollList" target="_blank">
                Click Here
              </a>
              <p>
                <span>&#8226;</span> In this application, we can create the
                entry for all the tollgate with the price for each vehicle type
                for both single and return journey, And also we create an entry
                for the vehicles which is passing that particular tollGate.
              </p>
              <p>
                <span>&#8226;</span> FrontEnd is done with React JS and hosted
                in Netlify.
              </p>
              <p>
                <span>&#8226;</span> BackEnd is done with Express JS and hosted
                in Render.
              </p>
            </li>

            <li>
              <strong> Expense Tracker</strong>
              <span> - </span>
              <a href="http://aviiiiii.online/expenseTracker" target="_blank">
                Click Here
              </a>
              <p>
                <span>&#8226;</span> In this application, we can entry our
                transactions and we can able to see the expense/income filtered
                with month or year or user.
              </p>
              <p>
                <span>&#8226;</span> FrontEnd is done with React JS and hosted
                in Netlify.
              </p>
              <p>
                <span>&#8226;</span> BackEnd is done with Express JS and hosted
                in Render.
              </p>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
}

export default Resume;
